export enum Pane {
    QuestionPane = 'QuestionPane',
    DetailsPane = 'DetailsPane',
    HistoryPane = 'HistoryPane',
}